/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import { array, arrayOf, bool, func, shape, string, oneOf } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import config from '../../config';
import routeConfiguration from '../../routeConfiguration';
import { ensureCurrentUser } from '../../util/data';
import { findOptionsForSelectFilter } from '../../util/search';
import { LISTING_STATE_PENDING_APPROVAL, propTypes } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
} from '../../util/urlHelpers';
import { formatMoney } from '../../util/currency';
import { createResourceLocatorString } from '../../util/routes';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import { richText } from '../../util/richText';
import {
  computeProfileData,
  computeProfilePoints,
  isProfileLiveEligible,
} from '../../components/ModalCompleteProfile/profilePoints';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import {
  Page,
  NamedLink,
  NamedRedirect,
  Modal,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  BookingPanel,
  MultiPurposeInfo,
} from '../../components';
import { TopbarContainer, NotFoundPage } from '../../containers';
import { ProjectBidForm, PayoutInfoMissingForm } from '../../forms';
import { TiLightbulb } from 'react-icons/ti';
import { MdCancel } from 'react-icons/md';

import {
  sendProjectBid,
  loadData,
  setInitialValues,
  fetchTransactionLineItems,
  checkUserExistingProposal,
} from './ProjectListingPage.duck';
import SectionHeading from './SectionHeading';
import SectionDescriptionMaybe from './SectionDescriptionMaybe';
import SectionHostMaybe from './SectionHostMaybe';
import SectionIconsMaybe from './SectionIconsMaybe';
import css from './ProjectListingPage.css';
import ActionBarMaybe from './ActionBarMaybe';
import facebookImage from '../../assets/freedomlySocialShare.png';

const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;

const { UUID } = sdkTypes;

const categoryLabel = (categories, key) => {
  const cat = categories.find(c => c.key === key);
  return cat ? cat.label : key;
};

const mainCategoryKey = (categories, key) => {
  const cat = categories.find(c => c.key === key);
  return cat && cat.parent ? cat.parent : key;
};

export class ProjectListingPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageClassNames: [],
      imageCarouselOpen: false,
      payoutInfoMissingModalOpen: false,
      payoutMissingAlreadyShown: false,
      profileNotLiveModalOpen: false,
    };

    this.onSubmitFillPayoutInfo = this.onSubmitFillPayoutInfo.bind(this);
    this.redirectToProposalPage = this.redirectToProposalPage.bind(this);
  }

  componentDidMount() {
    const { currentUser, params, onCheckUserExistingProposal } = this.props;

    // Check for existing proposals when component mounts with a logged-in user
    if (currentUser && currentUser.id) {
      const listingId = new UUID(params.id);
      onCheckUserExistingProposal(listingId, currentUser);
    }
  }

  componentDidUpdate(prevProps) {
    const { currentUser, params, onCheckUserExistingProposal } = this.props;
    const listingId = new UUID(params.id);

    // Check for existing proposals when user logs in
    const userJustLoggedIn = !prevProps.currentUser && currentUser && currentUser.id;

    // Check when navigating to a different listing
    const listingChanged = prevProps.params.id !== params.id;

    if (currentUser && currentUser.id && (userJustLoggedIn || listingChanged)) {
      onCheckUserExistingProposal(listingId, currentUser);
    }
  }

  onSubmitFillPayoutInfo() {
    const { history } = this.props;
    const routes = routeConfiguration();

    history.push(createResourceLocatorString('StripePayoutPage', routes, {}, {}));
  }

  redirectToProposalPage() {
    const {
      currentUser,
      history,
      params,
      location,
      stripeAccount,
      getListing,
      params: rawParams,
    } = this.props;
    const routes = routeConfiguration();

    if (!currentUser) {
      const state = { from: `${location.pathname}${location.search}${location.hash}` };

      // signup and return back to listingPage.
      history.push(createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}), state);
      return;
    }

    const listingId = new UUID(rawParams.id);
    const currentListing = ensureListing(getListing(listingId));

    const ensuredCurrentUser = ensureCurrentUser(currentUser);
    const currentUserLoaded = !!ensuredCurrentUser.id;

    // Only users whose profile is live may send applications. Live means the
    // required fields are filled and the profile-completeness points reach the
    // threshold (see isProfileLiveEligible).
    const profileData = computeProfileData(ensuredCurrentUser);
    const profileIsLive = isProfileLiveEligible(profileData, computeProfilePoints(profileData));
    if (!profileIsLive) {
      this.setState({ profileNotLiveModalOpen: true });
      return;
    }

    const stripeConnected = currentUserLoaded && !!stripeAccount && !!stripeAccount.id;
    const accountId = stripeConnected ? stripeAccount.id : null;
    const isLightEntrepreneur =
      ensuredCurrentUser &&
      ensuredCurrentUser.attributes &&
      ensuredCurrentUser.attributes.profile.publicData.account_role === 'light-entrepreneur';

    if (!params.slug) {
      const slug = createSlug(currentListing.attributes.title || '');
      params.slug = slug;
    }

    if ((stripeConnected && accountId) || isLightEntrepreneur) {
      history.push(createResourceLocatorString('ProjectProposalPage', routes, params, {}));
    } else {
      this.setState({
        payoutInfoMissingModalOpen: true,
        // payoutMissingAlreadyShown: true,
      });
    }
  }

  render() {
    const {
      unitType,
      isAuthenticated,
      currentUser,
      getListing,
      getOwnListing,
      intl,
      onManageDisableScrolling,
      params: rawParams,
      location,
      scrollingDisabled,
      showListingError,
      reviews,
      timeSlots,
      fetchTimeSlotsError,
      filterConfig,
      onFetchTransactionLineItems,
      lineItems,
      fetchLineItemsInProgress,
      fetchLineItemsError,
      sendProjectBidInProgress,
      sendProjectBidError,
      hasExistingProposal,
      existingProposalTransactionId,
      checkExistingProposalInProgress,
      applicationCount,
    } = this.props;

    const listingId = new UUID(rawParams.id);
    const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
    const currentListing =
      isPendingApprovalVariant || isDraftVariant
        ? ensureOwnListing(getOwnListing(listingId))
        : ensureListing(getListing(listingId));

    const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
    const params = { slug: listingSlug, ...rawParams };

    const listingType = isDraftVariant
      ? LISTING_PAGE_PARAM_TYPE_DRAFT
      : LISTING_PAGE_PARAM_TYPE_EDIT;
    // Always aim draft/edit entry at the draft panel; the wizard redirects an
    // incomplete draft back to the chat panel on its own (see tabsActive).
    const listingTab = 'draft';

    const isApproved =
      currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;

    const pendingIsApproved = isPendingApprovalVariant && isApproved;

    // If a /pending-approval URL is shared, the UI requires
    // authentication and attempts to fetch the listing from own
    // listings. This will fail with 403 Forbidden if the author is
    // another user. We use this information to try to fetch the
    // public listing.
    const pendingOtherUsersListing =
      (isPendingApprovalVariant || isDraftVariant) &&
      showListingError &&
      showListingError.status === 403;
    const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;

    if (shouldShowPublicListingPage) {
      return <NamedRedirect name="ListingPage" params={params} search={location.search} />;
    }

    const { description = '', price = null, title = '' } = currentListing.attributes;
    const descriptionText = currentListing.attributes.publicData.descriptionText;
    const publicData = currentListing.attributes.publicData || {};

    const richTitle = (
      <span>
        {richText(title, {
          longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
          longWordClass: css.longWord,
        })}
      </span>
    );

    const userPublicData =
      (currentUser &&
        currentUser.attributes &&
        currentUser.attributes.profile &&
        currentUser.attributes.profile.publicData) ||
      {};
    const { account_role = '' } = userPublicData;
    const isProvider = ['freelancer', 'light-entrepreneur'].includes(account_role);

    const bookingSubTitle = !currentUser
      ? intl.formatMessage({ id: 'ProjectListingPage.notLoggedIn' })
      : isProvider
      ? intl.formatMessage({ id: 'ProjectListingPage.bookingSubTitle' })
      : intl.formatMessage({ id: 'ProjectListingPage.bookingSubTitleNoBids' });

    const topbar = <TopbarContainer currentPage="ProjectListingPage" />;

    if (showListingError && showListingError.status === 404) {
      // 404 listing not found

      return <NotFoundPage />;
    } else if (showListingError) {
      // Other error in fetching listing

      const errorTitle = intl.formatMessage({
        id: 'ListingPage.errorLoadingListingTitle',
      });

      return (
        <Page title={errorTitle} scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.errorText}>
                <FormattedMessage id="ListingPage.errorLoadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    } else if (!currentListing.id || !currentListing.author) {
      // Still loading the listing or author data

      const loadingTitle = intl.formatMessage({
        id: 'ListingPage.loadingListingTitle',
      });

      return (
        <Page title={loadingTitle} scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.loadingText}>
                <FormattedMessage id="ListingPage.loadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    }

    const authorAvailable = currentListing && currentListing.author;
    const userAndListingAuthorAvailable = !!(currentUser && authorAvailable);
    const isOwnListing =
      userAndListingAuthorAvailable && currentListing.author.id.uuid === currentUser.id.uuid;
    const isClosed = currentListing.attributes.state === 'closed';
    const showContactUser =
      authorAvailable &&
      (!currentUser || (currentUser && isProvider && !isOwnListing)) &&
      !isClosed &&
      !hasExistingProposal;

    const currentAuthor = authorAvailable ? currentListing.author : null;
    const ensuredAuthor = ensureUser(currentAuthor);
    const authorStripeConnected = !!(
      currentAuthor &&
      currentAuthor.attributes.profile.publicData &&
      currentAuthor.attributes.profile.publicData.stripeConnected
    );

    // When user is banned or deleted the listing is also deleted.
    // Because listing can be never showed with banned or deleted user we don't have to provide
    // banned or deleted display names for the function
    const authorDisplayName = userDisplayNameAsString(ensuredAuthor, '');

    const bookingTitle = (
      <FormattedMessage
        id="ProjectListingPage.bookingTitle"
        values={{ title: currentListing.attributes.title }}
      />
    );

    const formattedPrice = formatMoney(intl, price);

    const listingImages = (listing, variantName) =>
      (listing.images || [])
        .map(image => {
          const variants = image.attributes.variants;
          const variant = variants ? variants[variantName] : null;

          // deprecated
          // for backwards combatility only
          const sizes = image.attributes.sizes;
          const size = sizes ? sizes.find(i => i.name === variantName) : null;

          return variant || size;
        })
        .filter(variant => variant != null);

    const facebookImages = listingImages(currentListing, 'facebook');
    const twitterImages = listingImages(currentListing, 'twitter');
    const siteTitle = config.siteTitle;
    const schemaTitle = intl.formatMessage(
      { id: 'ProjectListingPage.schemaTitle' },
      { title, price: formattedPrice, siteTitle }
    );

    const hostLink = (
      <NamedLink
        className={css.authorNameLink}
        name="ProjectListingPage"
        params={params}
        to={{ hash: '#host' }}
      >
        {authorDisplayName}
      </NamedLink>
    );

    const editParams = {
      id: listingId.uuid,
      slug: listingSlug,
      type: listingType,
      tab: listingTab,
    };

    const actionBar = currentListing.id ? (
      <div className={css.actionBarContainer} onClick={e => e.stopPropagation()}>
        <ActionBarMaybe
          isOwnListing={isOwnListing}
          listing={currentListing}
          editParams={editParams}
        />
      </div>
    ) : null;

    const categoryOptions = findOptionsForSelectFilter('category', filterConfig);
    const category =
      publicData && publicData.category ? (
        <span>{categoryLabel(categoryOptions, publicData.category)}</span>
      ) : null;

    const schemaDescriptionPlaceholder = intl.formatMessage(
      { id: 'ListingPage.schemaDescriptionPlaceholder' },
      {
        title,
      }
    );

    const multiPurposeDescription = intl.formatMessage({
      id: 'ProjectListingPage.multiPurposeDescription',
    });

    const averageReviewRating = () => {
      const reviewRating = reviews.map(review => review.attributes.rating);
      const average = reviewRating.reduce((a, b) => a + b, 0) / reviewRating.length;
      return average;
    };

    const schemaReviews = reviews?.map(review => {
      const publishedDateTemp = new Date(review.attributes.createdAt);
      const reviewRating = review.attributes.rating;
      const reviewBody = review.attributes.content;
      const reviewAuthor = review.author.attributes.profile.displayName;
      const year = publishedDateTemp.getFullYear();
      const month = publishedDateTemp.getMonth();
      const day = publishedDateTemp.getDate();
      const datePublished = `${year}-${month + 1}-${day}`;

      return {
        '@type': 'Review',
        author: reviewAuthor,
        datePublished: datePublished,
        reviewBody: reviewBody,
        reviewRating: {
          '@type': 'Rating',
          ratingValue: reviewRating,
          bestRating: '5',
          worstRating: '1',
        },
      };
    });

    const canonicalURL = `${process.env.REACT_APP_CANONICAL_ROOT_URL}/pl/${createSlug(title)}/${
      currentListing.id.uuid
    }`;

    const schemaImage = `${config.canonicalRootURL}${facebookImage}`;

    const schema = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: schemaTitle,
      image: schemaImage,
      description: descriptionText
        ? descriptionText.replace(/<\/?[^>]+(>|$)/g, '')
        : schemaDescriptionPlaceholder,
      review: schemaReviews,
      brand: {
        '@type': 'Brand',
        name: 'Freedomly',
      },

      offers: {
        '@type': 'AggregateOffer',
        offerCount: '1',
        price: price.amount / 100,
        priceCurrency: 'EUR',
        url: canonicalURL,
        availability: 'https://schema.org/InStock',
      },

      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: averageReviewRating(),
        reviewCount: reviews.length,
      },
    };

    if (currentListing.attributes.publicData.listingType === 'service') {
      return (
        <NamedRedirect
          name="ListingPage"
          params={{
            slug: createSlug(currentListing.attributes.title || ''),
            id: currentListing.id.uuid,
          }}
          search={location.search}
        />
      );
    }

    return (
      <Page
        title={schemaTitle}
        scrollingDisabled={scrollingDisabled}
        author={authorDisplayName}
        contentType="website"
        description={description}
        facebookImages={facebookImages}
        twitterImages={twitterImages}
        schema={schema}
        listingCanonicalURL={canonicalURL}
      >
        <LayoutSingleColumn className={css.pageRoot}>
          <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
          <LayoutWrapperMain>
            <div className={css.contentContainer}>
              <div className={css.multiPurposeInfoContainer}>
                {isOwnListing ? (
                  actionBar
                ) : isClosed ? (
                  <div className={css.closedListingBanner}>
                    <div className={css.closedBannerIcon}>
                      <MdCancel />
                    </div>
                    <div className={css.closedBannerContent}>
                      <h3 className={css.closedBannerTitle}>
                        <FormattedMessage id="ProjectListingPage.closedListingTitle" />
                      </h3>
                      <p className={css.closedBannerMessage}>
                        <FormattedMessage id="ProjectListingPage.closedListing" />
                      </p>
                    </div>
                  </div>
                ) : (
                  <MultiPurposeInfo
                    showWarning={true}
                    warningMessage={multiPurposeDescription}
                    icon={<TiLightbulb />}
                  />
                )}
              </div>
              <SectionHeading
                richTitle={richTitle}
                category={category}
                categoryKey={publicData.category}
                mainCategory={mainCategoryKey(categoryOptions, publicData.category)}
                mainCategoryLabel={categoryLabel(
                  categoryOptions,
                  mainCategoryKey(categoryOptions, publicData.category)
                )}
                hostLink={hostLink}
                showContactUser={showContactUser}
                hasExistingProposal={hasExistingProposal}
                existingProposalTransactionId={existingProposalTransactionId}
                checkExistingProposalInProgress={checkExistingProposalInProgress}
                user={ensuredAuthor}
                onContactUser={this.redirectToProposalPage}
                publicData={publicData}
                applicationCount={applicationCount}
              />
              <SectionDescriptionMaybe
                publicData={publicData}
                onContactUser={this.redirectToProposalPage}
                showContactUser={showContactUser}
                hasExistingProposal={hasExistingProposal}
                existingProposalTransactionId={existingProposalTransactionId}
                checkExistingProposalInProgress={checkExistingProposalInProgress}
              />
              <SectionHostMaybe
                title={title}
                listing={currentListing}
                authorDisplayName={authorDisplayName}
                onContactUser={this.redirectToProposalPage}
                currentUser={currentUser}
                hasExistingProposal={hasExistingProposal}
              />
            </div>
            {typeof window === 'object' ? <ReactTooltip /> : null}
            <Modal
              id="ProjectListingPage.payoutInfoMissing"
              contentClassName={css.enquiryModalContentProjectListing}
              isOpen={this.state.payoutInfoMissingModalOpen}
              onClose={() => {
                this.setState({ payoutInfoMissingModalOpen: false });
                // this.redirectToProposalPage();
              }}
              onManageDisableScrolling={onManageDisableScrolling}
            >
              <PayoutInfoMissingForm
                className={css.enquiryForm}
                submitButtonWrapperClassName={css.enquirySubmitButtonWrapper}
                listingTitle={title}
                authorDisplayName={authorDisplayName}
                sendEnquiryError={sendProjectBidError}
                onSubmit={this.onSubmitFillPayoutInfo}
                inProgress={sendProjectBidInProgress}
              />
            </Modal>
            <Modal
              id="ProjectListingPage.profileNotLive"
              contentClassName={css.enquiryModalContentProjectListing}
              isOpen={this.state.profileNotLiveModalOpen}
              onClose={() => this.setState({ profileNotLiveModalOpen: false })}
              onManageDisableScrolling={onManageDisableScrolling}
            >
              <div className={css.profileNotLiveContent}>
                <h2 className={css.profileNotLiveHeading}>
                  <FormattedMessage id="ProjectListingPage.profileNotLiveTitle" />
                </h2>
                <p className={css.profileNotLiveText}>
                  <FormattedMessage id="ProjectListingPage.profileNotLiveMessage" />
                </p>
                <NamedLink name="ProfileSettingsPage" className={css.profileNotLiveButton}>
                  <FormattedMessage id="ProjectListingPage.profileNotLiveButton" />
                </NamedLink>
              </div>
            </Modal>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

ProjectListingPageComponent.defaultProps = {
  unitType: config.bookingUnitType,
  currentUser: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  timeSlots: null,
  fetchTimeSlotsError: null,
  filterConfig: config.custom.filters,
  lineItems: null,
  fetchLineItemsError: null,
};

ProjectListingPageComponent.propTypes = {
  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string,
  }).isRequired,

  unitType: propTypes.bookingUnitType,
  // from injectIntl
  intl: intlShape.isRequired,

  params: shape({
    id: string.isRequired,
    slug: string,
    variant: oneOf([LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT]),
  }).isRequired,

  isAuthenticated: bool.isRequired,
  currentUser: propTypes.currentUser,
  getListing: func.isRequired,
  getOwnListing: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  scrollingDisabled: bool.isRequired,
  showListingError: propTypes.error,
  reviews: arrayOf(propTypes.review),
  fetchReviewsError: propTypes.error,
  timeSlots: arrayOf(propTypes.timeSlot),
  fetchTimeSlotsError: propTypes.error,
  onInitializeCardPaymentData: func.isRequired,
  filterConfig: array,
  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.Auth;
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendProjectBidInProgress,
    sendProjectBidError,
    hasExistingProposal,
    existingProposalTransactionId,
    checkExistingProposalInProgress,
    existingProposalError,
    applicationCount,
  } = state.ProjectListingPage;
  const {
    getAccountLinkInProgress,
    getAccountLinkError,
    createStripeAccountInProgress,
    createStripeAccountError,
    updateStripeAccountError,
    fetchStripeAccountError,
    stripeAccount,
    stripeAccountFetched,
  } = state.stripeConnectAccount;
  const { currentUser } = state.user;

  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  return {
    getAccountLinkInProgress,
    getAccountLinkError,
    createStripeAccountInProgress,
    createStripeAccountError,
    updateStripeAccountError,
    fetchStripeAccountError,
    stripeAccount,
    stripeAccountFetched,
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendProjectBidInProgress,
    sendProjectBidError,
    hasExistingProposal,
    existingProposalTransactionId,
    checkExistingProposalInProgress,
    applicationCount,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onFetchTransactionLineItems: (bookingData, listingId, isOwnListing) =>
    dispatch(fetchTransactionLineItems(bookingData, listingId, isOwnListing)),
  onSendProjectBid: (listingId, description, amount) =>
    dispatch(sendProjectBid(listingId, description, amount)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  onCheckUserExistingProposal: (listingId, currentUser) =>
    dispatch(checkUserExistingProposal(listingId, currentUser)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ProjectListingPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(ProjectListingPageComponent);

ProjectListingPage.setInitialValues = initialValues => setInitialValues(initialValues);
ProjectListingPage.loadData = loadData;

export default ProjectListingPage;
